import { Injectable } from '@angular/core';
import { Country } from '@app/models';
import {
  CountriesActionTypes,
  FetchCountries,
  FetchCountriesFail,
  FetchCountriesSuccess
} from '@app/pcs/actions/country';
import { CountryDataService } from '@app/pcs/services/country-data.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, exhaustMap, switchMap } from 'rxjs/operators';

@Injectable()
export class CountryEffects {

  fetchCountries$ = createEffect(() => this.actions$.pipe(
    ofType<FetchCountries>(CountriesActionTypes.FetchCountries),
    exhaustMap(() =>
      this.countryDataService.getCountries().pipe(
        switchMap((countries: Country[]) => of(new FetchCountriesSuccess(countries))),
        catchError(error => of(new FetchCountriesFail(error)))
      )
    )
  ));

  constructor(
    private actions$: Actions,
    private store: Store<any>,
    private countryDataService: CountryDataService
  ) {
  }
}
